import React, { useEffect, useState } from 'react';

import { Mandarin, ParadisePink, PurpleNavy } from '@core/theme/baseTheme';
import TeamsIcon from '@mui/icons-material/Groups';
import AgentsIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PartnersIcon from '@mui/icons-material/ZoomInMap';
import { useLanguage } from 'Context/LanguageContext';

import TextIcon from '~/TextIcon/TextIcon.component';
import Tooltip from '~/Tooltip/Tooltip.component';

function CellUsersNumber({ isochronous, extendedInfo }) {
	const { agentsCount, partnersCount, teamsCount } = isochronous;

	const lan = useLanguage();

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			{agentsCount > 0 && (
				<TextIcon
					className='mx-1'
					icon={
						<Tooltip title={lan.totalNumberOfAgents} color={PurpleNavy} arrow placement='left'>
							<AgentsIcon className='' style={{ height: '17px', color: PurpleNavy }} />
						</Tooltip>
					}
					text={extendedInfo ? `${lan.totalNumberOfAgents} - ${agentsCount}` : agentsCount}
					textStyle={{ fontSize: '0.9rem' }}
				/>
			)}
			{teamsCount > 0 && (
				<TextIcon
					className='mx-1'
					icon={
						<Tooltip title={lan.totalNumberOfTeams} color={ParadisePink} arrow placement='left'>
							<TeamsIcon className='' style={{ height: '17px', color: ParadisePink }} />
						</Tooltip>
					}
					text={extendedInfo ? `${lan.totalNumberOfTeams} - ${teamsCount}` : teamsCount}
					textStyle={{ fontSize: '0.9rem' }}
				/>
			)}

			{partnersCount > 0 && (
				<TextIcon
					className='mx-1'
					icon={
						<Tooltip title={lan.totalNumberOfAccountPartner} color={Mandarin} arrow placement='left'>
							<PartnersIcon className='' style={{ height: '17px', color: Mandarin }} />
						</Tooltip>
					}
					text={extendedInfo ? `${lan.totalNumberOfAccountPartner} - ${partnersCount}` : partnersCount}
					textStyle={{ fontSize: '0.9rem' }}
				/>
			)}

			{partnersCount === 0 && agentsCount === 0 && teamsCount === 0 && (
				<TextIcon
					className='mx-1'
					icon={
						<Tooltip title={lan.noUsers} color={ParadisePink} arrow placement='left'>
							<PersonOffIcon className='' style={{ height: '17px', color: ParadisePink }} />
						</Tooltip>
					}
					text={lan.noUsers}
					textStyle={{ fontSize: '0.9rem' }}
				/>
			)}
		</div>
	);
}

export default CellUsersNumber;
